var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg172(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 131,
    viewBox: "0 0 78 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.8184 1C53.4851 23.6667 8.81836 70.5 1.81843 104C-5.413 138.608 36.8183 132 67.8183 120",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0495 88C37.7943 90.3991 40.8192 93.9014 37.5495 96.4444C36.5202 97.245 33.9156 97.4488 33.2717 96C31.2197 91.3829 41.377 86.1454 44.0495 85",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg172);
export default __webpack_public_path__ + "static/media/172.2d4c47c1cbb442ec2f8e802c4071ed63.svg";
export { ForwardRef as ReactComponent };